// extracted by mini-css-extract-plugin
export default {"body":"AiAssistantPanel_body__QXZQY","messages":"AiAssistantPanel_messages__gfQPg","history":"AiAssistantPanel_history__Nrluc","resizeHandle":"AiAssistantPanel_resizeHandle__bIZ+n"};